import { createReducer } from "@reduxjs/toolkit";
import va from "@ob/layouts/VendorOnboarding/redux/actions";
import { AdminInfoStateType } from "@ob/layouts/VendorOnboarding/types/kyb/admin/info";

export const initAdminInfoStateType = {
  firstName: "",
  lastName: "",
  email: "",
  ssn: "",
  dob: "",
  title: "",
};

const adminInfoReducer = createReducer<AdminInfoStateType>(
  initAdminInfoStateType,
  (builder) => {
    builder
      .addCase(va.kyb.admin.info.setFirstName, onSetFirstName)
      .addCase(va.kyb.admin.info.setLastName, onSetLastName)
      .addCase(va.kyb.admin.info.setEmail, onSetEmail)
      .addCase(va.kyb.admin.info.setSSN, onSetSSN)
      .addCase(va.kyb.admin.info.setDOB, onSetDOB)
      .addCase(va.kyb.admin.info.setTitle, onSetTitle);
  },
);
export default adminInfoReducer;

export function onSetFirstName(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setFirstName>,
) {
  state.firstName = action.payload.value;
}

export function onSetLastName(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setLastName>,
) {
  state.lastName = action.payload.value;
}

export function onSetEmail(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setEmail>,
) {
  state.email = action.payload.value;
}

export function onSetSSN(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setSSN>,
) {
  state.ssn = action.payload.value;
}

export function onSetDOB(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setDOB>,
) {
  state.dob = action.payload.value;
}

export function onSetTitle(
  state: AdminInfoStateType,
  action: ReturnType<typeof va.kyb.admin.info.setTitle>,
) {
  state.title = action.payload.value;
}
